import { createFileRoute } from '@tanstack/react-router';

import { BookingSuccessScreen } from '@/features/booking/components/BookingSuccessScreen';

export const Route = createFileRoute('/client/book/success/$sessionId')({
  component: ClientBookSuccessRoute,
});

function ClientBookSuccessRoute() {
  const { sessionId } = Route.useParams();
  return <BookingSuccessScreen sessionId={sessionId} />;
}
